import type { Listing } from '@smg-real-estate/hg-rets-schema';

import { GUEST_EMAIL } from '@/constants/guest';
import { isHgRetsEmailFormat } from '@/helpers/validations';

/** Align guest lister.username with contact email before PUT (matches insertion-funnel-api behaviour). */
export function normalizeGuestUsernameInPlace(listing: Listing): void {
  const { username, email } = listing.lister ?? {};
  if (username === GUEST_EMAIL && email && isHgRetsEmailFormat(email)) {
    listing.lister!.username = email;
  }
}
